// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2rOmr","validationTips":"StatementDescriptor_validationTips__eojuK"};